module.exports = __webpack_public_path__ + "static/media/jj-help1.aca40ab1.png";